import Vue from 'vue'
import VueRouter from 'vue-router'
import Index1 from '../views/Index.vue'
// import child from './indexChild'
import { getUsercode } from '@/utils/auth'
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
// routes.push({path: `/frame/`, name: 'frame', component: () => import(`@/components/Frame/frame`), child})
const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Index1,

      children: [
        {
          path: '/',
          component: () => import('../views/Home.vue')
        },
        {
          path: '/index/Meeting',
          name: 'Meeting',

          component: () => import('../views/Meeting.vue')
        },
        {
          path: '/MeetingReservation',
          name: 'MeetingReservation',

          component: () => import('../views/MeetingReservation.vue')
        },
        {
          path: '/index/work',
          name: 'Work',
          component: () => import('../views/Work.vue')
        },
        {
          path: '/index/myMeeting',
          name: 'myMeeting',
          component: () => import('../views/myMeeting.vue')
        },
        // {
        //   path: '/index/about',
        //   name: 'About',
        //   component: () => import('../views/About.vue')
        // },
        {
          path: '/index/about',
          name: 'About',
          component: () => import('../views/About.vue')
        },
        {
          path: '/index/myMeetingDetails',
          name: 'myMeetingDetails',
          component: () => import('../components/myMeeting/myMeetingDetails.vue')
        },
        // 教育积分一览
        {
          path: '/index/EducationalPoints',
          name: 'EducationalPoints',
          component: () => import('../views/EducationalPoints/EducationalPoints.vue')
        }
        // ,
        // // 教育积分申请
        // {
        //   path: '/EducationalPointsApply',
        //   name: 'EducationalPointsApply',
        //   component: () => import('../views/EducationalPoints/EducationalPointsApply.vue')
        // }
      ]
    },
    // 教育积分申请
    {
      path: '/EducationalPointsApply',
      name: 'EducationalPointsApply',
      component: () => import('../views/EducationalPoints/EducationalPointsApply.vue')
    },
    {
      path: '/leave/create',
      name: 'Create',
      component: () => import('../views/Work/components/Create.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/resource',
      name: 'Resource',
      component: () => import('../views/Resource.vue')
    },
    {
      path: '/resourcevice',
      name: 'ResourceVice',
      component: () => import('../views/ResourceVice.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    const usercode = getUsercode()
    if (usercode != null && typeof (usercode) !== 'undefined') {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
